<template>
  <div>
    <div v-if="equipmentData" class="organism-server-info_container">
      <span class="equipment__name">{{ equipmentData.name }}</span>
      <div>
        <molecule-edit-tag
          :tagList="equipmentData.tag"
          :optionTagList="optionTagList"
          :isEditable="hasUpdatePermission"
          @updateCurrentEquipmentTagList="updateCurrentEquipmentTagList"
        ></molecule-edit-tag>
      </div>
      <div class="mt-1">
        <span><b>IP Address:</b> {{ equipmentData.ipAddress }}</span>
      </div>
      <div class="row w-100 equipment__description">
        <div class="col-12">{{ equipmentData.description }}</div>
      </div>
    </div>
    <div v-else class="organism-server-info_container-no-data d-flex w-100 flex-column align-items-center justify-content-center">
      <feather-icon icon="CloudOffIcon" class="empty-data__icon"></feather-icon>
      <label class="empty-data__text--title">No Data</label>
    </div>
  </div>
</template>

<script>
import MoleculeEditTag from "@/components/molecules/serverManagementModule/server/MoleculeEditTag"
export default {
  components: { MoleculeEditTag },
  name: "OrganismServerInformation",
  props: {
    equipmentData: {
      type: [Object, null],
      required: false,
      default: null,
    },
    optionTagList: {
      type: Array,
      required: true,
    },
    hasUpdatePermission: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    updateCurrentEquipmentTagList(tagList) {
      this.$emit("updateCurrentEquipmentTagList", tagList)
    },
  },
}
</script>

<style lang="scss" scoped>
.organism-server-info_container, .organism-server-info_container-no-data {
  padding: 15px 15px 15px 15px;
}

.organism-server-info_container-no-data {
  height: calc(100vh - 13.5rem);
}

.equipment__name {
  font-weight: 700;
  font-size: 30px;
  color: #7367f0;
}

.equipment__description {
  margin-top: 20px;
}

.empty-data__icon {
  width: 100px;
  height: 100px;
}

.empty-data__text--title {
  color: #5e5873;
  font-weight: 500;
  font-size: 18px;
  margin-top: 20px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .organism-server-info_container, .organism-server-info_container-no-data {
    padding: 31px 38px 21px 38px;
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
